import { ImageParams } from '~/src/common/typings/image';
import { getImageUrlFromFormat } from '~/src/common/utils/cloudinary';
import { GetRecipeByIdOrSlug200ImagesItem } from '~/src/queries/api-ecom/generated/api-ecom.schemas';

export const prepareSliderImagesFromProduct = (images: GetRecipeByIdOrSlug200ImagesItem[]) =>
  images.map(image => ({
    id: image.id,
    name: image.name,
    ratio: image.formats?.find(({ id: imageId }) => imageId === 'square')?.ratio,
    url: getImageUrlFromFormat(image, 'square', ImageParams.productPage),
    thumb: getImageUrlFromFormat(image, 'square', ImageParams.productThumbnail),
    large: getImageUrlFromFormat(image, undefined, ImageParams.zoomedIn),
  }));
